import { createFeatureSelector, createSelector } from '@ngrx/store';
import { type CartIconState } from './shop-cart-icon.reducer';

export const selectCartIconState = createFeatureSelector<CartIconState>('cartIcon');
export const selectCartIconData = createSelector(selectCartIconState, (state) => state.data);
export const selectIsCartEnabled = createSelector(selectCartIconState, (state) => state.isCartEnabled);
export const selectIconPositionType = createSelector(selectCartIconState, (state) => state.data?.iconPositionType);
export const selectCartIconLoading = createSelector(selectCartIconState, (state) => state.loading);
export const selectCartSettingsChanged = createSelector(selectCartIconState, (state) => state.isChanged);
